import React, { useEffect, useState } from "react";
import Button from "../../../components/Buttons/Button";
import SelectListField from "../../../components/Fields/SelectListField";
import { FormConfig } from "../../../components/Fields/Types";
import useSelectListOptions from "../../../components/Hooks/SelectListOptionsHook/useSelectListOptions";
import useValidation from "../../../components/Hooks/ValidationHook/useValidation";
import Popup from "../../../components/Popups/Popup";
import { useNotifications } from "../../../contexts/notificationContext";
import DataService from "../../../services/data.service";
import { DataResult, Result } from "../../../types/Result";

interface ReAssignUserModel {
    taskId: number[]
    userId?: number
}

interface IProps {
    show: boolean
    onHide: () => void
    taskId: number
}

const SuspendWorkflowPopup: React.FC<IProps> = ({ show, onHide, taskId }) => {
    const defaultFormData = {
        taskId: [taskId],
    }
    const [formData, setFormData] = useState<ReAssignUserModel>(defaultFormData);
    const users = useSelectListOptions('api/v1/selectlist/users?activeOnly=true', '-- Select user');

    const [serverErrors, setServerErrors] = useState<DataResult<ReAssignUserModel>>({ isSuccesful: true, messages: [], data: undefined });
    const { handleResult, handleException } = useNotifications();

    useEffect(() => {
        setFormData(defaultFormData);
    }, [show]);

    function submit() {
        if (formData) {
            DataService
                .post<Result>('api/v1/WorkflowTasks/' + taskId + '/ReAssignTo/' + formData.userId, undefined)
                .then(response => {
                    handleResult(response);
                    if (response.isSuccesful === true && onHide) {
                        onHide();
                    }
                })
                .catch(e => handleException(e));
        }
    }

    function onFieldChanged(name: string, value: string): void {
        formData[name] = value;
        setFormData(formData);
    }

    const formConfig: FormConfig = {
        fields: [
            { name: 'userId', label: 'Assign to', labelSize: 2, validationRules: [{ type: 'isRequired' }] },
        ],
        handleSubmit: submit,
        handleFieldChanged: onFieldChanged,
        showErrors: 'always',
    };

    const { getFieldProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    return (
        <Popup show={show} onHide={onHide} size={'lg'} title={'Reassign task to another user'} >
            <Popup.Body>
                <SelectListField {...getFieldProps('userId')} options={users} />
            </Popup.Body>
            <Popup.Footer>
                <Button {...getSubmitButtonProps()} text='Reassign' fill />
            </Popup.Footer>
        </Popup>
    );
}
export default SuspendWorkflowPopup;